module.exports = __webpack_public_path__ + "img/edit2_g.d0c028bc.svg";